import React from "react";
import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";
const ResponsiveEllipsis = ({ text, maxLine, displayInline = false }) => {
  const ResponsiveEllipsisHOC = responsiveHOC()(LinesEllipsis);
  return (
    <React.Fragment>
      <div
        title={text}
        className={`${displayInline === true ? "d-inline" : ""}`}
      >
        <ResponsiveEllipsisHOC
          text={text}
          maxLine={maxLine}
          ellipsis="..."
          trimRight
          basedOn="letters"
          className={`${displayInline === true ? "d-inline" : ""}`}
        />
      </div>
    </React.Fragment>
  );
};

export default ResponsiveEllipsis;
